export const getFlyoutData = (state) => state.flyout.data;

export const isFlyoutLoading = (state) => state.flyout.loading;
